import { IUpdateContratoInformacoesUseCase } from "../../../presentation/useCases/update/update_contrato_informacoes_use_case";
import { ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";

export class UpdateContratoInformacoesUseCase implements IUpdateContratoInformacoesUseCase {
  constructor(private readonly repository: ITerceirizacaoRepository) {}

  async updateContratoInformacoes(
    IdContratoInformacoes: number,
    IdContrato: number,
    DescInformacoes: string | null,
    Responsavel: string | null,
    IdFuncionario: number | null,
    Data: Date | null,
  ): Promise<void> {
    await this.repository.updateContratoInformacoes(
      IdContratoInformacoes,
      IdContrato,
      DescInformacoes,
      Responsavel,
      IdFuncionario,
      Data,
    );
  }
}
